import { useEffect, useState, useRef } from "react";
import styles from "./OverlayImage.module.css";

interface OverlayImageProps {
  src: string;
  alt?: string;
  text?: string;
  isImgEvent?:boolean
  onClick?: () => void;
}

export default function OverlayImage({ src, alt = "", text = "Click para reproducir", isImgEvent = false , onClick }: OverlayImageProps) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const imageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowOverlay(true);
          setFadeOut(false);

          // Ocultar después de 3 segundos
          const timer = setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => setShowOverlay(false), 500);
          }, 500);

          return () => clearTimeout(timer);
        }
      },
      { threshold: 0.1 } // Se activa cuando el 10% de la imagen es visible
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);

  return (
    <div
      className={styles.container}
      onClick={onClick}
      ref={imageRef}
      onMouseEnter={() => {
        setShowOverlay(true);
        setFadeOut(false);
      }}
      onMouseLeave={() => setFadeOut(true)}
    >
      <img src={src} alt={alt} className={isImgEvent ? styles.imageEvent : styles.image} />
      {showOverlay && (
        <div className={`${styles.overlay} ${fadeOut ? styles.fadeOut : ""}`}>
          {text}
        </div>
      )}
    </div>
  );
}
